module.exports = __webpack_public_path__ + "img/no-meat.32b3915b.svg";